// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { fontConfig } from "@vanmeter/XDL/constants";
import Close from "@vanmeter/XDL/Icons/IconClose";
import { buttonTransparent } from "@vanmeter/XDL/PreStyle/button";
import { xBaseTheme } from "@vanmeter/XDL/types";
import color from "@vanmeter/XDL/Utilities/color";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        typographyProps: {
            ...fontConfig.smallSingleLine,
            weight: fontConfig.weight.regular,
            color: "common.white",
            css: css`
                margin: 0;
                letter-spacing: 0;
            `,
        },
        color: "primary",
        iconProps: {
            src: Close,
            color: "common.ui1",
            width: 9,
            height: 11,
        },
        css: css`
            min-height: 26px;
            border-radius: 13px;
            align-items: center;
            word-break: break-all;
            gap: 6px;
            padding: 4px 8px;
            margin: 0 8px 8px 0;

            &:hover {
                background-color: ${color("common.ui15")};
            }
            button {
                margin: 0;
                flex-basis: unset;
                height: 18px;
                display: flex;
                align-self: flex-start;
                ${buttonTransparent}
            }
        `,
    },
} as xBaseTheme["tag"];
